<template>
  <modal>
    <div class="modal-header">
      <h4>อัปโหลดวิดีโอ</h4>
      <button
        @click="onCloseModal"
        type="button"
        class="btn btn-sm btn-close-container p-0 mr-3">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div>
      <SelectUploadType
        v-if="step === 1"
        :isEdit="isEdit"
        :onDeleteVideo="onDeleteVideo"
        :onClickNext="onClickNext"
        :onClose="onCloseModal" />
        <div class="content" v-if="step === 2">
          <YoutubeUploader
            v-if="type === 'youtube'"
            :isEdit="isEdit"
            :onClickUpload="onClickUpload"
            :onClickBack="onClickBack" />
          <SelectTpbsVod
            v-if="type === 'select-vod'"
            :isEdit="isEdit"
            :onClickUpload="onClickUpload"
            :onClickBack="onClickBack" />
        </div>
        <small class="text-danger ml-auto" v-if="errorCode">
          พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code : {{errorCode}}
        </small>
      </div>
  </modal>
</template>

<script>
/* eslint-disable no-undef */
import Modal from '@/components/Modal.vue';

import { uploadVideo, uploadMultipleVideos, getUploadToken } from './api';
import SelectTpbsVod from './SelectTpbsVod.vue';
import SelectUploadType from './SelectUploadType.vue';
import YoutubeUploader from './YoutubeUploader.vue';

export default {
  /* eslint-disable no-underscore-dangle */
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
    },
    onVideoChange: {
      type: Function,
    },
    onDeleteVideo: {
      type: Function,
    },
  },
  components: {
    Modal,
    YoutubeUploader,
    SelectUploadType,
    SelectTpbsVod,
  },
  data() {
    return {
      data: null,
      step: 1,
      type: null,
      errorCode: null,
      qoder: null,
    };
  },
  mounted() {
    this.setQoderUrl();
  },
  methods: {
    async setQoderUrl() {
      const response = await getUploadToken();
      qoder.config.url = response.data.webSdkUrl;
    },
    async onClickUpload(body) {
      if (body) {
        if (this.isEdit) {
          this.onVideoChange(body.media);
        } else {
          this.uploadNewVideo(body);
        }
      }
    },
    async uploadNewVideo(body) {
      try {
        const response = await uploadVideo(body);
        this.$router.push(`/videos/${response.data.id}`);
      } catch (error) {
        this.errorCode = error.response.data.statusCode;
      }
    },
    uploadVod() {
      const option = {
        multiple: false,
        skipEditing: true,
      };
      try {
        qoder.browseVideo((video) => {
          if (!video) return;
          const body = {
            type: 'vod',
            title: video.title,
            media: {
              type: 'qoder',
              sourceKey: video.key,
            },
          };
          this.onClickUpload(body);
        }, option);
      } catch (error) {
        this.errorCode = error.response.data.statusCode;
      }
    },
    uploadVodMultiple() {
      const option = {
        multiple: true,
        skipEditing: true,
      };
      try {
        qoder.browseVideo(async (videos) => {
          if (!videos) return;
          const payload = videos.map((video) => {
            const body = {
              type: 'vod',
              title: video.title,
              media: {
                type: 'qoder',
                sourceKey: video.key,
              },
            };
            return body;
          });
          await uploadMultipleVideos(payload);
          this.$router.push('/videos?multiple=true');
        }, option);
      } catch (error) {
        this.errorCode = error.response.data.statusCode;
      }
    },
    onCloseModal() {
      if (this.onClose) {
        this.onClose();
        return;
      }
      this.$router.back();
    },
    onClickBack() {
      this.step = 1;
    },
    onClickNext(type) {
      if (type === 'vod') {
        this.uploadVod();
        this.onCloseModal();
      } else if (type === 'vod-multiple') {
        this.uploadVodMultiple();
        this.onCloseModal();
      }
      this.step = 2;
      this.type = type;
    },
  },
};
</script>
